// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3Hg8M","additionalInfo":"AgreementModal_additionalInfo__1NYmX"};